<script lang="ts">
  import ControlsModal from '$components/Accessibility/Modal/ControlsModal.svelte';
  import Footer from '$components/News/Footer/Footer.svelte';
  import NavbarModal from '$components/Navigation/NavbarModal.svelte';
  import SideRails from '$components/Common/SideRails.svelte';

  import { page } from '$app/stores';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

<div class:brand-reskin-bg={brandReskinEnabled}>
  <SideRails />
  <slot />
  <div class="footer">
    <Footer document={$page.data.footer} />
  </div>
  <NavbarModal document={$page.data.secondaryNavData} />
  <ControlsModal />
</div>

<style lang="scss">
  .brand-reskin-bg {
    background-color: #fbfbfb;
  }

  .footer {
    --theme-button-secondary-button-default-foreground-color: var(--twist-color-gray-100);
    --theme-button-secondary-button-active-foreground-color: var(--twist-color-gray-100);
    --theme-button-secondary-button-hover-focus-foreground-color: var(--twist-color-gray-100);
    --theme-button-secondary-button-default-background-color: var(--twist-color-gray-0);
    --theme-button-secondary-button-active-background-color: #e2e2e2;
    --theme-button-secondary-button-hover-focus-background-color: #e2e2e2;
  }
</style>
